<template>
  <div class="d-flex align-center justify-center">
    <div
      class="hamochi-container-x"
      @click="dailyQuest()"
      style="cursor: pointer"
    >
      <div v-if="xp.currentLevel < 3 && showLevelBubble" class="speech-bubble">
        {{ $t("string.questMsg3") }}
      </div>

      <!-- Mission bubble -->
      <div
        v-else-if="isMissionAvailable"
        class="speech-bubble"
        @click.stop="goToMissionExplore"
      >
        <div class="bubble-content">
          <div class="d-flex align-center justify-center">
            <span>⚠️</span>
            <span class="mx-1">{{ $t("string.missionAvailable") }}</span>
            <v-avatar size="18" color="error" class="white--text font-weight-bold">{{ missions.length }}</v-avatar>
          </div>
        </div>
      </div>

      <!-- Quest bubble -->
      <div v-else-if="isAvailable" class="speech-bubble">
        <div class="bubble-content">
          <div>
            <v-icon color="amber" small> mdi-flag </v-icon>
            {{ $t("string.dailyQuest") }}
          </div>
          <transition name="fade-transition">
            <v-progress-linear
              v-if="snackbar"
              color="light-blue"
              height="15"
              :value="(current / next) * 100"
              striped
              rounded
            >
              {{ current }} / {{ next }}
            </v-progress-linear>
          </transition>
        </div>
      </div>
      <div class="d-flex flex-column align-center justify-center">
        <v-img
          :src="require('@/assets/world/hamochi.png')"
          max-width="100"
          height="80"
          contain
          class="d-flex align-center justify-center text-center flip-horizontal"
        ></v-img>
        <div class="hm-name">Hamochi</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  components: {
    //
  },
  computed: mapState({
    auth: (state) => state.auth.data,
  }),
  props: [
    //
  ],
  data: () => ({
    isAvailable: false,
    isMissionAvailable: false,
    snackbar: false,
    showLevelBubble: false,
    current: 0,
    next: 0,
    api: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    xp: {
      currentLevel: 0,
      currentXp: 0,
      nextLevel: 0,
      nextXpThreshold: 1,
    },
    missions: [],
  }),
  async created() {
    await this.loadXP();
    await this.getMission();
  },
  mounted() {
    //
  },
  methods: {
    dailyQuest() {
      console.log(this.isMissionAvailable);
      // If mission available, go to mission page
     
      if (this.isMissionAvailable) {
        this.$router.push({ name: "PageExploreDailyMission", query: { tab: "mission" }  });
        return;
      }
      if (this.xp.currentLevel >= 3) {
        this.$router.push({
          name: "PageExploreDailyMission",
          query: { tab: "quest" }
        });
      } else {
        // Show bubble for low level users when clicked
        this.showLevelBubble = true;
        // Hide bubble after 3 seconds
        setTimeout(() => {
          this.showLevelBubble = false;
        }, 3000);
      }
    },
    goToMissionExplore() {
      // Navigate to mission explore page
      this.$router.push({ name: "PageExploreDailyMission", query: { tab: "mission" }  });
    },
    async loadXP() {
      this.api.url =
        this.$api.servers.game +
        "/api/v1/" +
        this.$_getLocale() +
        "/game/xp/load";
      this.api.callbackReset = () => {
        this.api.isLoading = true;
        this.api.isError = false;
        this.api.error = null;
      };
      this.api.callbackError = (e) => {
        this.api.isLoading = false;
        this.api.isError = true;
        this.api.error = e;
        console.error(e);
      };
      this.api.callbackSuccess = (resp) => {
        this.api.isLoading = false;
        this.xp = resp;
      };
      await this.$api.fetch(this.api);
    },
    async getQuest() {
      this.quests = [];
      this.api.url =
        this.$api.servers.game +
        "/api/v1/" +
        this.$_getLocale() +
        "/game/quest/visit";

      this.api.callbackReset = () => {
        this.api.isLoading = true;
        this.api.isError = false;
        this.api.error = null;
      };
      this.api.callbackError = (e) => {
        this.api.isLoading = false;
        this.api.isError = true;
        this.api.error = e;
      };
      this.api.callbackSuccess = async (resp) => {
        this.api.isLoading = false;
        this.current = resp.Save.data.day - 1;
        this.next = resp.Save.data.day;
        this.isAvailable = this.isQuestUnclaimed(
          resp.Quest,
          resp.Save.data.day
        );
        if (this.isAvailable) {
          setTimeout(() => {
            this.snackbar = true;
            setTimeout(() => {
              this.current = this.next;
              setTimeout(() => {
                this.snackbar = false;
              }, 3000);
            }, 1000);
          }, 1000);
        }
      };
      this.api.params = {
        model: "DailyLogin",
        modelKey: "DLQV01",
      };

      await this.$api.fetch(this.api);
    },
    async getMission() {
      this.missions = [];
      this.api.url =
        this.$api.servers.game +
        "/api/v1/" +
        this.$_getLocale() +
        "/game/mission/visit";

      this.api.callbackReset = () => {
        this.api.isLoading = true;
        this.api.isError = false;
        this.api.error = null;
      };
      this.api.callbackError = (e) => {
        this.api.isLoading = false;
        this.api.isError = true;
        this.api.error = e;
      };
      this.api.callbackSuccess = async (resp) => {
        this.api.isLoading = false;
        this.missions = resp.Mission || [];
        this.isMissionAvailable = this.missions.length > 0;
        if (this.isMissionAvailable) {
          setTimeout(() => {
            this.snackbar = true;
            setTimeout(() => {
              this.current = this.next;
              setTimeout(() => {
                this.snackbar = false;
              }, 3000);
            }, 1000);
          }, 1000);
        } else {
          if (this.xp.currentLevel >= 3) {
            await this.getQuest();
          }
        }
      };
      this.api.params = {
        model: "DailyLogin",
        modelKey: "DLQV01",
      };

      await this.$api.fetch(this.api);
    },
    isQuestUnclaimed(questArray, day) {
      // Ensure day is between 1 and 7
      if (day < 1 || day > 7) {
        console.error("Day must be between 1 and 7.");
        return false;
      }

      const questKey = `QT_DAILY_COLLECT_DAY_${day}_LOGIN`;

      const quest = questArray.find((q) => q.key === questKey);

      if (!quest) {
        console.warn(`No quest found for day ${day}`);
        return false;
      }

      return quest.PlayerQuest && quest.PlayerQuest.timestampClaimed === null;
    },
  },
};
</script>

<style scoped>
.quest-snack {
  z-index: 999;
  width: 100%;
  max-width: 200px;
  padding: 10px;
  background-color: #fff9f1;
  border-radius: 5px;
  border: #ccaf8b 4px solid;
  color: #785c3a;
}

.disable-btn-q {
  filter: grayscale(100%);
}

.hamochi-container-x {
  width: 100%;
  max-width: 480px;
  display: flex;
  justify-content: center;
  padding-left: 80px;
  position: relative;
}

/* Speech Bubble Styles */
.speech-bubble {
  position: absolute;
  bottom: 100px;
  left: 50%;
  transform: translateX(-50%);
  margin-left: 40px;
  background-color: #ffffff;
  border: 3px solid #ccaf8b;
  border-radius: 15px;
  padding: 12px 16px;
  font-size: 14px;
  font-weight: 500;
  color: #785c3a;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 10;
  max-width: 200px;
  word-wrap: break-word;
  text-align: center;
  animation: speechBubbleAppear 0.3s ease-out;
}

/* Speech bubble tail pointing down to Hamochi */
.speech-bubble::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 12px solid transparent;
  border-right: 12px solid transparent;
  border-top: 12px solid #ffffff;
}

.speech-bubble::before {
  content: "";
  position: absolute;
  top: calc(100% + 2px);
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 15px solid transparent;
  border-right: 15px solid transparent;
  border-top: 15px solid #ccaf8b;
}

.bubble-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: 100%;
}

@keyframes speechBubbleAppear {
  0% {
    opacity: 0;
    transform: translateX(-50%) scale(0.8) translateY(10px);
  }

  100% {
    opacity: 1;
    transform: translateX(-50%) scale(1) translateY(0);
  }
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .speech-bubble {
    font-size: 12px;
    padding: 10px 12px;
    max-width: 160px;
    bottom: 100px;
  }
}

.flip-horizontal {
  transform: scaleX(-1);
}

.hm-name {
  margin-top: -5px;
  font-size: 12px;
}
</style>